import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Cookies from "js-cookie";
import { API_BASE } from "./constants/api";

// Global fetch wrapper to automatically attach JWT authorization headers and cookies to all API requests
const originalFetch = window.fetch;
window.fetch = async function (resource, options = {}) {

  const resourceUrl = typeof resource === "string"
    ? resource
    : (resource instanceof URL ? resource.toString() : (resource && resource.url) || "");

  if (resourceUrl.includes(API_BASE) || resourceUrl.includes("api.bewta.com")) {
    const token = Cookies.get("token");
    const headers = options.headers ? { ...options.headers } : {};
    if (token) {
      headers["authorization"] = `Bearer ${token}`;
    }
    options.headers = headers;
    options.credentials = "include";
  }
  return originalFetch.call(this, resource, options);
};


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    {/* <ApolloProvider client={client}> */}
      <App />
    {/* </ApolloProvider> */}
    </BrowserRouter>
  </React.StrictMode>
);
